import React from 'react';
import classNames from 'classnames';
import styles from './TimeReminderModal.module.css';
import sharedButtonStyles from '../button/Button.module.css';

export default function TimeReminderModal({ time = 0, onCancel }) {
  return (
    <div className={styles.mainContainer}>
      <div>
        Friendly reminder that only
        {' '}
        {time}
        {' '}
        minutes of the session remain!
      </div>
      <div className={styles.buttonContainer}>
        <button className={classNames(sharedButtonStyles.FCButton, sharedButtonStyles.short)} type="button" onClick={() => onCancel()}>Dismiss</button>
      </div>
    </div>
  );
}
